angular.module('listingOverviewModule').component('listingBuildingApts', {
    templateUrl: 'listingBuildingApts/listingBuildingApts.html',
    bindings: {
        buildingName: '@',
        buildingImg: '@',
        rpcSaveToProfile: '@',
        rpc: '@',
    },
    controller: ['$sce', '$element', '$timeout', 'crResourcesService', function ($sce, $element, $timeout, crResourcesService) {
        var self = this;
        self.tabs = [];
        self.listings = {
            sale: [],
            rent: [],
            closing: []
        }
        self.hasVisibleTabs = true;
        self.totals = [];
        self.activeTab = 'sale';
        self.isLoading = false;
        self.buildingUrl = null;

        self.listingFieldsConfig = {
            sale: [
                { key: 'unit', label: 'Unit #', sortable: true },
                { key: 'beds', label: 'Beds', sortable: true },
                { key: 'baths', label: 'Baths', sortable: true },
                { key: 'size_raw', label: 'Size', sortable: true },
                { key: 'price_sqft_raw', label: 'Price / Ft²', sortable: true },
                { key: 'price_raw', label: 'Price', sortable: true },
                { key: 'listed_on', label: 'Listed On', sortable: true },
                { key: 'days_on_market', label: 'On Market', sortable: true }
            ],
            rent: [
                { key: 'unit', label: 'Unit #', sortable: true },
                { key: 'beds', label: 'Beds', sortable: true },
                { key: 'baths', label: 'Baths', sortable: true },
                { key: 'size_raw', label: 'Size', sortable: true },
                { key: 'price_sqft_raw', label: 'Price / Ft²', sortable: true },
                { key: 'price_raw', label: 'Price', sortable: true },
                { key: 'listed_on', label: 'Listed On', sortable: true },
                { key: 'days_on_market', label: 'On Market', sortable: true }
            ],
            closing: [
                { key: 'unit', label: 'Unit #', sortable: true },
                { key: 'beds', label: 'Beds', sortable: true },
                { key: 'baths', label: 'Baths', sortable: true },
                { key: 'size', label: 'Size', sortable: true },
                { key: 'sale_price', label: 'Closing Price', sortable: true },
                { key: 'price_sqft', label: 'Price / Ft²', sortable: true },
                { key: 'asking_price', label: 'Asking Price', sortable: true },
                { key: 'sale_date', label: 'Sold On', sortable: true }
            ]
        };
        
        this.setActiveTab = function (tab) {
            this.activeTab = tab;
        };

        this.isActiveTab = function (tab) {
            return this.activeTab === tab;
        };

        // Function to set the first available tab as active
        this.setFirstAvailableTab = function () {
            const availableTabs = ['sale', 'rent', 'closing'].filter((tabKey) => {
                return self.listings[tabKey] && self.listings[tabKey].length > 0;
            });

            if (availableTabs.length > 0) {
                self.setActiveTab(availableTabs[0]);
            }
        };
        
        this.sortingState = {
            field: null, // Currently sorted field
            order: 'asc' // Current sorting order ('asc' or 'desc')
        };

        this.sortBy = function (field) {
            // Toggle sorting order if the same field is clicked again
            if (self.sortingState.field === field) {
                self.sortingState.order = self.sortingState.order === 'asc' ? 'desc' : 'asc';
            } else {
                // Set new field and default order to ascending
                self.sortingState.field = field;
                self.sortingState.order = 'asc';
            }

            const orderMultiplier = self.sortingState.order === 'asc' ? 1 : -1;
            self.listings[self.activeTab] = self.listings[self.activeTab].sort((a, b) => {
                let valA = a[field] || '';
                let valB = b[field] || '';

                if (field === 'beds') {
                    valA = valA === 'Studio' ? 0 : parseInt(valA, 10);
                    valB = valB === 'Studio' ? 0 : parseInt(valB, 10);
                }

                if (field === 'baths') {
                    valA = parseInt(valA, 10);
                    valB = parseInt(valB, 10);
                }
                
                // Parse dates for sorting
                if (field.includes('date')) {
                    valA = new Date(valA).getTime();
                    valB = new Date(valB).getTime();
                }

                // Default numeric or string comparison
                if (valA < valB) return -1 * orderMultiplier;
                if (valA > valB) return 1 * orderMultiplier;
                return 0;
            });
        };
        
        this.formatPrice = function (rawValue) {
            if (!rawValue && rawValue !== 0) return '-';
            return `$${Math.round(parseFloat(rawValue)).toLocaleString()}`;
        };

        this.formatDate = function (rawDate) {
            if (!rawDate) return '-';
            const date = new Date(rawDate);
            return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
        };

        this.formatSize = function (sizeValue) {
            if (!sizeValue) return '-';
            return `${parseInt(sizeValue, 10).toLocaleString()} ft²`;
        };

        this.formatBeds = function (beds) {
            if (!beds) return '-';
            if (beds == 0 || beds == 'Studio') return 'Studio';
            return beds == 1 ? `${beds} bed` : `${beds} beds`;
        };

        this.formatBaths = function (baths) {
            if (!baths) return '-';
            return baths == 1 ? `${baths} bath` : `${baths || '-'} baths`;
        };

        this.formatDaysOnMarket = function (days) {
            if (!days && days !== 0) return '-'; // Handle missing or undefined values
            return `${days} ${days === 1 ? 'day' : 'days'}`;
        };

        // Initialize schools only when the component is visible
        this.checkVisibilityAndInit = function () {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {

                        self.isLoading = true; // Show loader
                        
                        self.loadAptsForSale();

                        observer.disconnect(); // Stop observing after initialization
                    }
                });
            }, {
                rootMargin: '200px',
            });

            observer.observe($element[0]);
        };

        // Initialize component
        this.$onInit = function () {
            // Trust the passed subway HTML for rendering
            self.trustedSubwayHtml = $sce.trustAsHtml(self.subwayHtml);

            // Start visibility check
            $timeout(() => {
                this.checkVisibilityAndInit();
            });
        };

        this.loadAptsForSale = function () {
            crResourcesService.get(self.rpc).$promise.then((resp) => {
                self.listings.sale = resp.availabilities.sale || [];
                self.listings.rent = resp.availabilities.rent || [];
                self.listings.closing = resp.closings || [];
                self.totals = resp.totals || {};
                self.buildingUrl = resp.building.url || null;

                self.tabs = [
                    { key: 'sale', label: 'Apartments For Sale', count: self.totals.sale },
                    { key: 'rent', label: 'Apartments For Rent', count: self.totals.rent },
                    { key: 'closing', label: 'Recent Sales', count: self.totals.closing }
                ];

                self.hasVisibleTabs = this.tabs.some(tab => tab.count > 0);

                self.setFirstAvailableTab();
                
                self.isLoading = false;
            });
        };

        this.openPopup = function(event, listing, type) {
            event.stopPropagation();
            if (!listing.blimp) {
                let galleryLink = event.target.closest('.listing-popup-link');
                listing.blimp = new BlimpExtV2(galleryLink, {
                    cache: true,
                    draggable: true,
                    show_veil: true,
                    fullscreen: true,
                    display: type,
                    put_others_behind: false,
                    onFetch: function() {
                        if (listing.markerLabel) {
                            listing.markerLabel.marker.clicked = true;
                        }

                        _gaq.push(['_trackEvent', 'map', 'loaded', 'view_listing']);
                    },
                    onPostRpc: function() {
                        this.add_extra(true);
                        Core.compile_html(this._element);
                    },
                });
                listing.blimp.handle_link_click();
            } else {
                listing.blimp.handle_link_click();
                listing.blimp.show_widget(type);
                if (type == 'gallery' && listing.blimp && listing.blimp.pagePhotogallery && listing.blimp.pagePhotogallery.pg && listing.blimp.pagePhotogallery.pg.current_index) {
                    listing.blimp.pagePhotogallery.pg.scrollMainToPosition(listing.blimp.pagePhotogallery.pg.current_index);
                }
            }
        };

    }],
});
